import { getSeatLimit as getLegacySubscriptionSeatLimit } from '../internal/legacySubscription/getSeatLimit';
import { getSeatLimit as getModernSubscriptionSeatLimit } from '../internal/modernSubscription/getSeatLimit';
import type { Subscription } from '../types';

import { isModernSubscription } from './isModernSubscription';

export function getSeatLimit(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return getModernSubscriptionSeatLimit(subscription);
  }

  return getLegacySubscriptionSeatLimit(subscription);
}
